import React from 'react';
import PropTypes from 'prop-types';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import ShareLinksSkeleton from '../ShareLinksSkeleton';
import { ContentInfo } from './ShareLinksActions.styles';
var ShareLinksActionsSkeleton = function ShareLinksActionsSkeleton(_ref) {
  var isDesktop = _ref.isDesktop;
  return React.createElement(ContentInfo, {
    "data-testid": "share-links-actions"
  }, isDesktop && React.createElement(React.Fragment, null, React.createElement(ShareLinksSkeleton, {
    width: "100%",
    variation: "text"
  }), React.createElement(ShareLinksSkeleton, {
    width: "100%",
    height: "52px",
    variation: "rectangular"
  })), React.createElement(ShareLinksSkeleton, {
    width: "100%",
    variation: "text"
  }), React.createElement(Flex, {
    justifyContent: "flex-start",
    gap: "20px"
  }, React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "center",
    gap: "8px"
  }, React.createElement(ShareLinksSkeleton, {
    width: "44px",
    height: "44px",
    variation: "circular"
  }), React.createElement(ShareLinksSkeleton, {
    width: "60px",
    variation: "text"
  })), React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "center",
    gap: "8px"
  }, React.createElement(ShareLinksSkeleton, {
    width: "44px",
    height: "44px",
    variation: "circular"
  }), React.createElement(ShareLinksSkeleton, {
    width: "60px",
    variation: "text"
  }))), React.createElement(ShareLinksSkeleton, {
    width: "100%",
    height: "32px",
    variation: "rectangular"
  }));
};
process.env.NODE_ENV !== "production" ? ShareLinksActionsSkeleton.propTypes = {
  isDesktop: PropTypes.bool.isRequired
} : void 0;
export default ShareLinksActionsSkeleton;